<template>
     <div class="container px-6 pb-8 pt-12 h-dvh text-n900 dark:bg-n0">
     <div class="flex justify-center items-center text-center flex-col">
        <h1 class="text-2xl font-medium dark:text-white">Sign In</h1>
        <p class="tet-sm text-n500 dark:text-darkN500 pt-3 px-4">
          Stay connected, follow teams, and never miss thrilling Stay connected
        </p>
      </div>

       <pulse-loader :loading="loading" :color="color" :size="size" style="position: absolute; top:20%;right: 45%;"></pulse-loader>

      <form @submit.prevent="login" class="flex flex-col gap-4 pt-8">
        <div class="flex flex-col justify-start">
          <p class="text-sm font-semibold pb-2 dark:text-white">Email</p>
          <div class="p-4 bg-n20 border border-n40 dark:bg-darkN20 dark:border-darkN40 rounded-xl">
            <input type="text"  v-model="email" placeholder="Enter email" class="w-full bg-transparent outline-none placeholder:text-n90 text-sm dark:text-white">
          </div>
        </div>
        <div class="flex flex-col justify-start">
          <p class="text-sm font-semibold pb-2 dark:text-white">Password</p>
          <div class="p-4 bg-n20 border border-n40 dark:bg-darkN20 dark:border-darkN40 rounded-xl flex justify-between items-center">
            <input type="password" v-model="password" placeholder="password" class="flex-1 bg-transparent outline-none placeholder:text-n90 text-sm passwordField dark:text-white">
            <i class="ph ph-eye-slash passowordShow cursor-pointer text-n90 text-lg !leading-none"></i>
          </div>
          <div class="flex justify-end pt-2">
            <a href="https://softivuspro.com/html/bankux/main-demo/forgot-password.html" class="text-sm font-medium text-g300">Forgot password?</a>
          </div>
        </div>
        <div class="my-3 flex">
          <button class="flex-1 py-3 bg-g300 text-white text-center rounded-xl">Sign In</button>
        </div>
      </form>
      <p v-if="error" style="color:red">{{ error }}</p>
      </div>

</template>

<script setup>
import { ref,onMounted} from "vue";
import { useRouter } from "vue-router";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

const email = ref("");
const password = ref("");
const error = ref(null);
const router = useRouter();

const loading = ref(false)

onMounted(async () => {

   const ceklog = localStorage.getItem("token");
   if(ceklog){
    router.push("/");
   }
      

})

async function login() {
  loading.value = true
  try {
    // contoh login API
      const formData = new FormData()
 
  formData.append("cmd", 'login')
  formData.append("email",  email.value)
  formData.append("password", password.value)

    const res = await fetch("https://kiyanrahayu.my.id/api2", {
      method: "POST",
  //     headers: { 
  //   "Content-Type": "application/json",
  //   "Accept": "application/json" // penting di Laravel
  // },
       body: formData,
    });
    const data = await res.json();

    console.log(res)

    if (res.ok && data.token) {
        loading.value = false
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      router.push("/");
    } else {
        loading.value = false
      error.value = data.message || "Login gagal";
    }
  } catch (err) {
      loading.value = false
    error.value = "Error server";
  }
}
</script>